'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPiOutline = function TiPiOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.5 11.9c-0.9-1-2.2-1.5-3.5-1.5s-2.6 0.5-3.5 1.5c-0.4 0.4-0.9 0.6-1.5 0.6s-1.1-0.2-1.5-0.6c-2.2-2.3-5.3-3.6-8.5-3.6s-6.3 1.3-8.5 3.6c-1 0.9-1.5 2.2-1.5 3.5s0.5 2.6 1.5 3.5c0.9 1 2.2 1.5 3.5 1.5v7.9c0 2.8 2.2 5 5 5s5-2.2 5-5c0 2.8 2.2 5 5 5s5-2.2 5-5v-6.9c1.3-0.6 2.5-1.4 3.5-2.5 1-0.9 1.5-2.2 1.5-3.5s-0.5-2.6-1.5-3.5z m-2.3 4.7c-1.3 1.3-2.9 2.1-4.5 2.4v9.3c0 1-0.8 1.7-1.7 1.7s-1.7-0.7-1.7-1.7v-9.3c-1.6-0.3-3.2-1.1-4.5-2.4-0.6-0.6-1.3-1.1-2.1-1.3v13c0 1-0.8 1.7-1.7 1.7s-1.7-0.7-1.7-1.7v-13c-0.8 0.2-1.5 0.7-2.1 1.3-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.7-0.6-1.7 0-2.4 1.7-1.7 4-2.5 6.2-2.5s4.5 0.8 6.2 2.5c1 1.1 2.4 1.6 3.8 1.6 1.4 0 2.8-0.5 3.8-1.6 0.3-0.3 0.8-0.5 1.2-0.5s0.9 0.2 1.2 0.5c0.6 0.7 0.6 1.7 0 2.4z' })
        )
    );
};

exports.default = TiPiOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pi-outline.js
// module id = 1971
// module chunks = 0